<template>
  <div :class="`cp-media-card -${media.format}`">
    <div class="container">
      <div class="container-img">
        <img
          :src="media.thumbnail"
          :alt="media.title"
          loading="lazy"
          width="332"
          height="407"
        >
        <div class="icon-type">
          <svg :class="`icon icon-media-${media.format}`"><use :xlink:href="`#icon-media-${media.format}`"></use></svg>
        </div>
      </div>
      <div class="-hover-block">
        <div class="-content">
          <div class="-type">
            {{ media.category.label }}
          </div>
          <div
            v-html="media.title"
            class="-title"
          >
            {{ media.title }}
          </div>
          <template v-if="media.format === 'video' || (media.format === 'podcast' && media.podcast_id) || media.format === 'image'">
            <div class="-middle">
              <button
                class="btn-video"
                @click="openModal"
              >
                <svg :class="`icon icon-media-${media.format}`"><use :xlink:href="`#icon-media-${media.format}`"></use></svg>
              </button>
            </div>
          </template>
          <template v-if="media.format === 'document'">
            <a
              class="btn btn-download"
              :href="media.permalink.url"
              rel="noopener"
              target="_blank"
              download
              @click="eventGTM(media)"
            >{{ media.card_button_label }}</a>
          </template>
          <template v-if="media.format === 'link'">
            <a
              class="btn btn-download"
              :href="media.permalink.url"
              rel="noopener"
              target="_blank"
              @click="eventGTM(media)"
            >{{ media.card_button_label }}</a>
          </template>
          <template v-if="media.format === 'podcast' && media.podcast_url">
            <a
              class="btn btn-download"
              :href="media.podcast_url"
              rel="noopener"
              target="_blank"
              @click="eventGTM(media)"
            >{{ media.card_button_label }}</a>
          </template>
        </div>
      </div>
    </div>
    <div class="-bottom">
      <div class="bottom-title">
        {{ media.title }}
      </div>
    </div>
    <media-modal
      v-if="activeModal"
      :source="mediaSource"
      :media="media"
      :type-player="typePlayer"
      :display-vodalys="displayVodalys"
      @close-modal="closeModal"
    />
  </div>
</template>

<script>
import MediaModal from './MediaModal';

export default {
  components: {
    MediaModal,
  },
  props: {
    media: {
      type: Object,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeModal: false,
    }
  },
  computed: {
    mediaSource() {
      if (this.media.format === 'video') {
        const videosList = [this.media.video_vodalys_id, this.media.video_id, this.media.video_m3u_url, this.media.video_iframe];
        return videosList;
      }
      return Object.entries(this.media)
        .filter(([key]) => ['image', 'podcast_id', 'video_vodalys_id', 'video_id'].includes(key))
        .find(([, entry]) => entry && entry.length > 0)[1] || 'n/a';
    },
  },
  methods: {
    openModal() {
      this.activeModal = true;
      document.body.classList.add('modal-is-open');
    },
    closeModal() {
      this.activeModal = false;
      document.body.classList.remove('modal-is-open');
    },
    eventGTM(media) {
      window.dataLayer.push({ event: 'gaEvent', eventCategory: 'Mediacenter interaction', eventAction: media.category.label })
    },
  },
}
</script>
